export default "__VITE_ASSET__D$uX8IzO__"